<template>
  <div
    v-if="addOns.length > 0"
    class="product-settings"
    :class="{ 'product-settings--open': showAddOns, 'product-settings--modal': type == 'modal' }"
  >
    <button
      class="product-settings__toggle"
      :class="{ 'product-settings__toggle--active': showAddOns, 'product-settings__toggle--small': type == 'modal' }"
      @click.prevent="toggleAddOns"
    >
      {{ $modeoL10n.additional_options }} <span class="product-settings__sum"><price
        prefix="+"
        :price-without-tax="addOnTotalWithoutTax"
        :price-with-tax="addOnTotalWithTax"
      /></span>
    </button>

    <div
      v-if="showAddOns"
      class="product-settings__content"
    >
      <div
        v-for="(addOn, index) in addOns"
        :key="addOn.id"
        class="product-setting"
      >
        <label
          class="product-setting__label"
          :for="'addon-' + addOn.id"
        >
          {{ $modeoL10n.as_addon }} <a
            class="product-setting__name content-link"
            :href="addOn.link"
            target="_blank"
          >{{ addOn.name }}</a>
          <button
            v-if="addOn.lead != ''"
            class="product-info-popover-button info-btn"
            :class="{ 'state-active': addOnInfo[index] }"
            @click.prevent="toggleAddonInfo(index)"
          >
            <span class="screen-reader-text">{{ $modeoL10n.additional_info_accessory }} {{ addOn.name }}</span>
          </button>
          <div
            v-if="addOnInfo[index]"
            class="product-info-popover"
          >
            <img
              v-if="addOn.image"
              v-lazy="addOn.image.productThumbnail"
              :srcset="addOn.image.productThumbnail + ' 1x, ' + addOn.image.productThumbnailX2 + ' 2x'"
              class="product-info-popover__image"
              alt=""
            >
            <div class="product-info-popover__text">{{ addOn.lead }}</div>
          </div>
        </label>
        <div class="product-setting__value">
          <div class="product-setting__field select">
            <select
              :id="'addon-' + addOn.id"
              v-model="selectedAddOns[addOn.id]"
              @change="addOnsChanged()"
            >
              <option :value="false">
                {{ $modeoL10n.select }}
              </option>
              <option
                v-if="!addOn.variations"
                :value="addOn"
              >
                {{ $modeoL10n.yes }} <template v-if="!hidePrices">
                  (<price
                    prefix="+"
                    :price-without-tax="addOn.prices_without_tax.price"
                    :price-with-tax="addOn.prices_with_tax.price"
                  />)
                </template>
              </option>
              <template v-if="addOn.variations">
                <option
                  v-for="variation in addOn.variations"
                  :key="variation.variation_id"
                  :value="variation"
                >
                  {{ variation.attribute_name }} <template v-if="!hidePrices">
                    (<price
                      prefix="+"
                      :price="variation.price"
                      :price-without-tax="variation.prices_without_tax.price"
                      :price-with-tax="variation.prices_with_tax.price"
                    />)
                  </template>
                </option>
              </template>
            </select>
          </div>

          <span
            v-if="selectedAddOns[addOn.id]"
            class="product-setting__price"
          >
            <span
              class="product-setting__price-amount price-amount"
              :class="{ 'price-amount--ins': selectedAddOns[addOn.id].price != selectedAddOns[addOn.id].regular_price }"
            ><price
              :price="selectedAddOns[addOn.id].price"
              :price-without-tax="selectedAddOns[addOn.id].prices_without_tax.price"
              :price-with-tax="selectedAddOns[addOn.id].prices_with_tax.price"
            /></span>
            <span
              v-if="selectedAddOns[addOn.id].price != selectedAddOns[addOn.id].regular_price"
              class="product-setting__price-amount price-amount price-amount--del"
            ><price
              :price="selectedAddOns[addOn.id].regular_price"
              :price-without-tax="selectedAddOns[addOn.id].prices_without_tax.regular_price"
              :price-with-tax="selectedAddOns[addOn.id].prices_with_tax.regular_price"
            /></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    import _ from 'lodash';

    export default {
        props: {
            type: {
                type: String,
                default: '',
            },
            addOns: {
                type: Array,
                default: function(){
                    return [];
                },
            },
            hidePrices: Boolean,
            originalSelectedAddOns: {
                type: Array,
                default: function () {
                    return [];
                },
            },
        },
        data : function () {
            return {
                selectedAddOns : {},
                showAddOns : false,
                addOnTotalWithTax : 0,
                addOnTotalWithoutTax : 0,
                addOnRegularPriceTotalWithTax : 0,
                addOnRegularPriceTotalWithoutTax : 0,
                addOnInfo: {},
            };
        },
        mounted: function () {
            if (!_.isEmpty( this.originalSelectedAddOns )) {
                let self = this;
                let selectedAddOns = _.clone(this.selectedAddOns);
                this.addOns.forEach(function(addOn) {
                    selectedAddOns[addOn.id] = self.getOriginallySelectedVariation(addOn);
                });
                this.selectedAddOns = selectedAddOns;
            } else {
                this.setDefaultValues();
            }

            this.updateAddOnTotal();
        },
        methods: {

            addOnsChanged() {
                this.updateAddOnTotal();
            },

            toggleAddOns() {
                this.showAddOns = !this.showAddOns;
            },

            getOriginallySelectedVariation(addOn) {
                for (let i = 0; i < this.originalSelectedAddOns.length; i++) {
                    let originalSelectedAddOn = this.originalSelectedAddOns[i];

                    if (addOn.type == 'simple' && originalSelectedAddOn.product_id == addOn.id) {
                        return addOn;
                    } else if (addOn.type == 'variation' && originalSelectedAddOn.product_id == addOn.id) {
                        //find correct variation...
                        for (let j = 0; j < addOn.variations.length; j++) {
                            let variation = addOn.variations[j];
                            if (variation.variation_id == originalSelectedAddOn.variation_id) {
                                return variation;
                            }
                        }
                    }
                }
                return false;
            },

            updateAddOnTotal() {
                let totalWithoutTax = 0;
                let totalWithTax = 0;
                let regularPriceTotalWithTax = 0;
                let regularPriceTotalWithoutTax = 0;

                for (let key in this.selectedAddOns) {
                    if (this.selectedAddOns[key] !== false) {
                        const pricesWithTax = this.selectedAddOns[ key ].prices_with_tax;
                        totalWithTax = totalWithTax + this.parseCommaDecimalFormat( pricesWithTax.price );
                        regularPriceTotalWithTax = regularPriceTotalWithTax + this.parseCommaDecimalFormat( pricesWithTax.regular_price );

                        const pricesWithoutTax = this.selectedAddOns[ key ].prices_without_tax;
                        totalWithoutTax = totalWithoutTax + this.parseCommaDecimalFormat( pricesWithoutTax.price );
                        regularPriceTotalWithoutTax = regularPriceTotalWithoutTax + this.parseCommaDecimalFormat( pricesWithoutTax.regular_price );
                    }
                }

                this.addOnTotalWithoutTax = totalWithoutTax;
                this.addOnTotalWithTax = totalWithTax;
                this.addOnRegularPriceTotalWithoutTax = regularPriceTotalWithoutTax;
                this.addOnRegularPriceTotalWithTax = regularPriceTotalWithTax;

                this.$emit('change', {
                    addOns: _.clone(this.selectedAddOns),
                    totals: {
                        totalRegularWithoutTax: this.addOnRegularPriceTotalWithoutTax,
                        totalWithoutTax: this.addOnTotalWithoutTax,
                        totalRegularWithTax: this.addOnRegularPriceTotalWithTax,
                        totalWithTax: this.addOnTotalWithTax,
                    },
                });
            },

            toggleAddonInfo(index) {
                let newAddonInfo = _.clone(this.addOnInfo);
                newAddonInfo[index] = newAddonInfo[index] ? !newAddonInfo[index] : true;
                this.addOnInfo = newAddonInfo;
            },

            setDefaultValues() {
                let selectedAddOns = _.clone(this.selectedAddOns);
                this.addOns.forEach(function(addOn) {
                    selectedAddOns[addOn.id] = false;
                });
                this.selectedAddOns = selectedAddOns;
                this.updateAddOnTotal();
            },

            clearSelections() {
                this.setDefaultValues();
                this.$emit('change', {
                    addOns: this.selectedAddOns,
                    totals: {
                        totalRegularWithoutTax: this.addOnRegularPriceTotalWithoutTax,
                        totalWithoutTax: this.addOnTotalWithoutTax,
                        totalRegularWithTax: this.addOnRegularPriceTotalWithTax,
                        totalWithTax: this.addOnTotalWithTax,
                    },
                });
            },

        },
    }
</script>
